/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Avg_Tx_Fee_Switch_To_UsdInputs */



/**
* | output |
* | --- |
* | "Switch Average Transaction Fee to USD" |
*
* @param {Metric_Avg_Tx_Fee_Switch_To_UsdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_avg_tx_fee_switch_to_usd = /** @type {((inputs?: Metric_Avg_Tx_Fee_Switch_To_UsdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Avg_Tx_Fee_Switch_To_UsdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch Average Transaction Fee to USD")
});